import { Checkbox } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { updateFirebaseDefaultUsers } from 'lib/firebase';
import { useState } from 'react';
import { DefaultUser } from 'types';

export interface DefaultUserCheckboxProps {
    supplierId: string;
    params: GridRenderCellParams;
    onDefaultUserUpdate: (updatedDefaultUser: DefaultUser) => void;
    field: 'issue' | 'threshold' | 'offline';
}
export const DefaultUserCheckbox = ({
    params,
    onDefaultUserUpdate,
    supplierId,
    field,
}: DefaultUserCheckboxProps) => {
    const [checked, setChecked] = useState(params.row[field]);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);

        params.row[field] = event.target.checked;

        updateFirebaseDefaultUsers(supplierId, params.row).then(() => {
            onDefaultUserUpdate(params.row);
        });
    };

    return (
        <div data-testid="DefaultUserCheckbox">
            <Checkbox checked={checked} onChange={onChange} />
        </div>
    );
};
